<template>
  <div class="actions-bar h-full flex flex-col items-center justify-center gap-4">
    <el-tooltip
      v-for="item in handleList" :key="item.type"
      :content="item.tip"
      placement="right"
      :open-delay="300"
      :disabled="(item.type === 'up' && disabledUp) || (item.type === 'down' && disabledDown) || (item.type === 'delete' && disabledDelete)"
    >
      <div
        class="actions-bar__item w-[36px] h-[36px] rounded-full flex items-center justify-center"
        :class="[{ 'disabled': (item.type === 'up' && disabledUp) || (item.type === 'down' && disabledDown) || (item.type === 'delete' && disabledDelete) }, item.type === 'delete' ? 'is-delete' : '']"
        @click.stop="item.handle"
      >
        <i class="item-icon text-18" :class="item.icon" />
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import { scrollTo } from '~/utils/dom'
export default {
  components: {
  },
  props: {
    selectWidget: {
      type: Object,
      default() {
        return {}
      }
    },
    widgetList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      handleList: [
        {
          type: 'up',
          icon: 'el-icon-top',
          disabled: false,
          handle: this.handleUp,
          tip: '上移'
        },
        {
          type: 'down',
          icon: 'el-icon-bottom',
          disabled: false,
          handle: this.handleDown,
          tip: '下移'
        },
        {
          type: 'delete',
          icon: 'el-icon-delete',
          disabled: false,
          handle: this.handleDelete,
          tip: '删除'
        }
      ]
    }
  },
  computed: {
    disabledUp() {
      let result = false
      const { selectWidget, widgetList } = this
      const current = selectWidget?.id || null
      if (!current) {
        result = true
      } else {
        const index = widgetList.findIndex(item => item.id === current)
        const prev = widgetList[index - 1]
        const prevInfo = prev?.getMenuInfo() || {}
        const curInfo = selectWidget?.getMenuInfo() || {}
        result = prev === undefined || (prevInfo.isDefault && !prevInfo.draggable) || (curInfo.isDefault && !curInfo.draggable)
      }
      return result
    },
    disabledDown() {
      let result = false
      const { selectWidget, widgetList } = this
      const current = selectWidget?.id || null
      if (!current) {
        result = true
      } else {
        const index = widgetList.findIndex(item => item.id === current)
        const next = widgetList[index + 1]
        const nextInfo = next?.getMenuInfo() || {}
        const curInfo = selectWidget?.getMenuInfo() || {}
        result = next === undefined || (nextInfo.isDefault && !nextInfo.draggable) || (curInfo.isDefault && !curInfo.draggable)
      }
      return result
    },
    disabledDelete() {
      let result = false
      const { selectWidget } = this
      if (!selectWidget) {
        result = true
      } else {
        const curInfo = selectWidget?.getMenuInfo() || {}
        result = curInfo.isDefault
      }
      return result
    }
  },
  methods: {
    handleUp() {
      const { selectWidget, widgetList } = this
      const index = widgetList.findIndex(item => item.id === selectWidget.id)
      const prev = index - 1
      this.$emit('up', index, prev)
      this.scrollToView()
    },
    handleDown() {
      const { selectWidget, widgetList } = this
      const index = widgetList.findIndex(item => item.id === selectWidget.id)
      const next = index + 1
      this.$emit('down', index, next)
      this.scrollToView()
    },
    scrollToView() {
      this.$nextTick(() => {
        const item = this.selectWidget
        if (item.id) {
          scrollTo(`${item.id}`, '.edit-content__center--wrapper')
        }
      })
    },
    handleDelete() {
      this.SiteMenu.openDeleteBlockDialog()
    }
  }
}
</script>

<style lang="less">
.actions-bar {
  padding: 0 5px;
  
  &__item {
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    width: 36px !important;
    height: 36px !important;
    border-radius: 12px !important; // 从圆形改为圆角矩形，更现代

    .item-icon {
      transition: all 0.3s ease;
      color: rgba(255, 255, 255, 0.6);
      font-size: 18px;
    }

    &:hover {
      transform: translateX(-4px) scale(1.05);
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(255, 255, 255, 0.2);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
      
      .item-icon {
        color: white;
        transform: scale(1.1);
      }
    }

    &:active {
      transform: translateX(-4px) scale(0.95);
      background: rgba(255, 255, 255, 0.05);
    }

    &.disabled {
      pointer-events: none;
      cursor: not-allowed;
      background: transparent;
      box-shadow: none;
      border-color: rgba(255, 255, 255, 0.05);
      
      .item-icon {
        opacity: 0.2;
      }
    }

    &.is-delete {
      border-color: rgba(255, 77, 79, 0.2);
      
      .item-icon {
        color: rgba(255, 77, 79, 0.8);
      }

      &:hover {
        background: linear-gradient(135deg, rgba(255, 77, 79, 0.2), rgba(255, 77, 79, 0.1)) !important;
        border-color: #ff4d4f !important;
        box-shadow: 0 8px 24px rgba(255, 77, 79, 0.25) !important;
        
        .item-icon {
          color: #ff4d4f !important;
        }
      }
    }
  }
}
</style>
